import { useTranslation } from 'react-i18next';

import { DataPanelItem } from '@/ui';
import type { EmergencyContact } from '@/signalr';
import { ContactRow } from './ContactRow';

export type ClosePersonContactPanelItemProps = {
  contacts: readonly EmergencyContact[];
};

export function ClosePersonContactPanelItem({ contacts }: ClosePersonContactPanelItemProps) {
  const { t } = useTranslation();

  if (contacts.length === 0) {
    return null;
  }

  return (
    <DataPanelItem title={t('Incident_InfoPanel_ClosePersonContact')}>
      {contacts.map((contact) => (
        <ContactRow
          key={`${contact.name}-${contact.phoneNumber}`}
          name={contact.name}
          phoneNumber={contact.phoneNumber}
        />
      ))}
    </DataPanelItem>
  );
}
